
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"57","width":"100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(0 .412)"}},[_c('rect',{attrs:{"fill":"#fff","height":"56","rx":"9.286","width":"100"}}),_c('g',{attrs:{"stroke-linecap":"round","stroke-width":"4.271"}},[_c('path',{attrs:{"d":"M25.67 17.717l-9.46 8.152a2.786 2.786 0 000 4.22l9.46 8.152m47.573-20.524l9.46 8.152a2.786 2.786 0 010 4.22l-9.46 8.152","stroke":"#4fdca7"}}),_c('path',{attrs:{"d":"M56.033 15.9L42.386 39.895","stroke":"#ededf4"}})])])])
          )
        }
      }
    